<template>
	<form class="list-item list-item-multi-row" :class="{active:edit}" @submit.prevent="saveItem">
		<div class="column">

			<div class="row separated centering">

			 	<label class="field inline row">
				   	<span class="label centered rigid">{{label}}</span>
				   	<span class="row value centering">
						<slot v-if="edit" ref="inputRef" name="setting-input"></slot>
						<div class="display-text centered rigid" v-else>{{displayValue}}</div>
						<slot v-if="edit" name="help-text"></slot>
					</span>
				</label>

				<span class="gap">
					<slot name="error-inline"></slot>
					<slot name="success-inline"></slot>
					<slot name="updating-inline"></slot>
				</span>

				<footer class="row rigid separated">
					<div class="row" v-if="!edit">
						<button class="rigid centered" :disabled="!canEdit" type="button" @click="editItem">{{buttonText}}</button>
					</div>

					<div v-else class="row rigid separated">
						<button class="link rigid centered" type="button" v-if="!hideCancel" @click="resetItem">Cancel</button>
						<button v-if="!requirePassword && !hideCommit" class="rigid centered" type="submit" value="Submit"> {{commitButtonText || 'Save'}}</button>
					</div>
				</footer>
			</div>

			<slot class="row centering" name="success-block"></slot>
			<slot class="row centering" name="error-block"></slot>

			<collapsible :open="edit">
				<slot class="row centering" name="info-block"></slot>
			</collapsible>

		</div>

		<!-- Require account password to change security settings -->
		<collapsible :open="edit && requirePassword" :class="{open:edit && requirePassword}">

			<div class="legend-footer row centering">
				<blockquote v-if="status && status.error && status.error.authPasswordInvalid" class="notice error right gap">
					It appears that this password was wrong.
				</blockquote>
				<small class="gap" v-else><i class="fas fa-lock"></i> A password is required to change this setting.</small>
				<span class="row rigid">
					<input placeholder="Account Password" class="rigid centered" type="password" v-model="accountPassword"/>
					<span class="hairline"></span>
					<button class="rigid centered" type="submit" :disabled="accountPassword.length < 1 || submitting" value="Submit">Apply</button>
				</span>
			</div>

		</collapsible>
	</form>
</template>

<script>
import Vue from 'vue';
import Collapsible from './Collapsible.vue';
export default {
	name: 'SettingInput',
	data() {
		return {
			edit: false,
			intialValue: null,
			accountPassword: '',
			modelNotProvided: this.model === undefined,
			inputValue: this.model || '',
			prevSibling: null,
			submitting: false,
		};
	},
	props: {
		label: String,
		model: String,
		displayValue: String,
		placeholder: String,
		buttonText: String,
		hideCancel: Boolean,
		hideCommit: Boolean,
		commitButtonText: String,
		inputType: String,
		inputRef: String,
		requirePassword: Boolean,
		status: Object,
		onCommit: Function,
		onReset: Function,
		canEdit: Boolean,
		setActive: Boolean
	},
	methods: {
		getSettingInputElm() {
			return this.$slots && this.$slots['setting-input'] && this.$slots['setting-input'][0];
		},
		getSettingInputValue() {
			const elm = this.getSettingInputElm();
			return elm && elm.data && elm.data.domProps && elm.data.domProps.value;
		},
		editItem() {
			const vm = this;

			// select previous selector for styling
			vm.prevSibling = this.$el.previousElementSibling;
			if (vm.prevSibling) {
				vm.prevSibling.classList.add('prev-item');
			}

			this.$root.$emit('active', this.inputRef);

			this.onReset();

			Vue.nextTick()
				.then(() => {
					const settingInput = this.getSettingInputElm();
					// if setting has an input set focus to it
					if (settingInput) {
						this.settingInput = settingInput;
						this.settingInput.elm.focus();
					}

				});
		},
		saveItem() {
			this.submitting = true;
			const vm = this;

			if (this.accountPassword === '') {
				this.submitting = false;
				return;
			}

			// if setting doesn't have an input move account password to first parameter (i.e. delete account)
			return this.onCommit(this.accountPassword)
				.then(response => {
					this.submitting = false;
					vm.resetComponent();
				}, () => {
					this.submitting = false;
				});
		},
		resetItem(e) {
			this.inputValue = this.initialValue;
			this.resetComponent();
			this.onReset();
		},
		resetComponent() {
			this.accountPassword = '';
			this.edit = false;
			if (this.prevSibling) {
				this.prevSibling.classList.remove('prev-item');
			}
		}
	},
	components: {
		Collapsible
	},
	watch: {
		model: function (newValue, oldValue) {
			this.inputValue = newValue;
		   	}
	   	},
	mounted() {
		if (this.setActive) {
			this.editItem();
		}
	},
	created() {
		if (this.onReset) {
			this.onReset();
		}

		this.initialValue = this.model;

		this.$root.$on('active', (ref) => {
			this.edit = (this.inputRef === ref);

			if (!this.edit) {
				this.resetItem();
			}
		});
	}
};

</script>



// WEBPACK FOOTER //
// ./src/components/SettingInput.vue